import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class IspService {
    url = environment.ispUrl;

    constructor(private http: HttpClient) {
    }

    getIsp(): Observable<any> {
        return this.http.get(this.url).pipe(
            catchError((error: HttpErrorResponse) => observableThrowError(error.error || 'Server error')));
    }

}
